export default __webpack_public_path__ + "static/media/shopify-logo.fde50708.png";